

// --------------------HEADER----------------------//

function modifyWeatherText() {
  setInterval(function () {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (!weatherBugSet && str != '') {
      $('#weatherBugWidget').addClass('weatherBugSet');
      var findSpace = str.lastIndexOf(' ');
      var stringLength = str.length;
      var res = str.substring(findSpace, stringLength);
      var start = str.substring(0, findSpace);
      $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
      $('#weatherBugWidget').css('visibility', 'visible');
    }
  }, 12);
}

function modifyCountdown() {
  function addOnly() {
    var countdownDays = $('.countdownDays');
    var countdownDaysText = countdownDays.html();
    countdownDays.html(countdownDaysText.replace(/(\d+)/, "Only $1"));
  }

  var bodyElement = $('body');
  var siteInfoBannerWidget = $('#siteInfoBannerWidget');

  if (bodyElement.hasClass('siteInfoBannerWidgetDateIsPast') || bodyElement.hasClass('siteInfoBannerWidgetEventHappening')) {
    siteInfoBannerWidget.css('opacity', '1');
  } else {
    setTimeout(function () {
      addOnly();
      siteInfoBannerWidget.css('opacity', '1');
    }, 1500);
  }
}





function modifyBtnTickets() {
  const btnTickets = document.querySelector('.header .ticket');
  btnTickets.classList.replace('ticket', 'button');
  btnTickets.classList.add('button-tickets');
  btnTickets.textContent = 'Buy tickets';
  btnTickets.setAttribute('aria-label', 'Click here to buy tickets')
  btnTickets.setAttribute('aria-hidden', 'true')
}

function modifyBtnNavToggle() {
  const navToggle = document.querySelector('.mobile-nav-toggle');

  navToggle.innerHTML = `
    <span></span>
    <span></span>
    <span></span>
  `;
  navToggle.setAttribute('tabindex', '0')
  navToggle.setAttribute('role', 'button')
  navToggle.setAttribute('aria-label', 'open menu')
}

function modifyMobileMenu() {
  const subHeader = document.querySelector('.mobile-menu-subheader')
  const ticketsMobile = document.querySelector('.mobile-menu-ticket-btn')

  ticketsMobile.remove();
  subHeader.innerHTML = '';
}

// --------------------FOOTER----------------------//

function modifyFooterSuscribe() {
  const footer = document.querySelector('footer');
  const suscribe = footer.querySelector('.emailSignup');
  const suscribeTxt = suscribe.querySelector('.emailSignupText');
  const suscribeInput = suscribe.querySelector('.inputFieldTextbox.textbox');
  const suscribeInputPlaceholder = 'Enter email adress'
  const suscribeBtn = suscribe.querySelector('.emailInputSubmit a');

  suscribeTxt.textContent = 'Get updates!'
  suscribeInput.value = suscribeInputPlaceholder
  suscribeBtn.textContent = 'Subscribe'


  suscribeInput.addEventListener('focus', function () {
    this.value = '';
  });

  suscribeInput.addEventListener('blur', function () {
    if (this.value === '') {
      this.value = suscribeInputPlaceholder;
    }
  });
}

// --------------------CALL FUNCTIONS----------------------//

if (window.location.pathname === '/') {
  $(document).ready(function () {

  });


}

$(window).load(function () {

  modifyCountdown();
  modifyWeatherText();

})

$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');


  modifyBtnTickets();
  modifyBtnNavToggle();
  modifyMobileMenu();
  modifyFooterSuscribe();

});



